module.exports = __webpack_public_path__ + "img/brands.46fc5532.png";